var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.002 20H26.002V30H22.002V20ZM22 32H26V36H22V32Z",
    fill: "#F1B44C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5361 8.4C26.8401 7.09 25.4841 6.276 24.0001 6.276C22.5161 6.276 21.1601 7.09 20.4641 8.402L5.78808 36.128C5.12608 37.38 5.16608 38.85 5.89608 40.064C6.62608 41.276 7.90608 42 9.32208 42H38.6781C40.0941 42 41.3761 41.276 42.1061 40.064C42.8341 38.852 42.8761 37.38 42.2141 36.128L27.5361 8.4ZM9.32208 38L24.0001 10.274L38.6881 38H9.32208Z",
    fill: "#F1B44C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningError);
export default __webpack_public_path__ + "static/media/warning-error.7396703b262b3decdeea9cbc5c90456f.svg";
export { ForwardRef as ReactComponent };